export default {
	path: '/address-manage',
	meta: {
		title: '地址管理',
    hasFooter: true
  },
	component: r => require.ensure([], () => r(require(`./index.vue`)), `/address-manage`),
}



// WEBPACK FOOTER //
// ./src/views/AddressManage/router.js